import styled from 'styled-components';
import { IconChevronRight } from '@toolshed/styleguide/components/AppIcon/AppIcons';
import NextLink from 'next/link';
import { spacing4, spacingInlineNarrow } from 'lib/mortar';
import { BodyText } from 'lib/design-system';
import { colors } from '@checkatrade/web-ui/themes';

const Nav = styled.nav`
  display: flex;
  align-items: flex-end;
  max-width: var(--search-page-max-width, 1030px);
  width: calc(100% - (2 * var(--edge-spacing, ${spacing4})));
  box-sizing: border-box;
  margin: var(--breadcrumb-top-margin, 0) var(--edge-spacing, ${spacing4}) 0;
`;

const Ol = styled.ol`
  display: inline;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const Breadcrumb = styled(BodyText)`
  display: inline;
  span {
    display: inline-block;
    vertical-align: text-bottom;
  }
`;

const BreadcrumbLocation = styled(Breadcrumb)`
  text-transform: capitalize;
  vertical-align: bottom;
`;

const SearchBreadcrumbs = ({
  breadcrumbs,
  location,
}: {
  breadcrumbs: any[];
  location: string;
}) => {
  if (breadcrumbs.length <= 1) {
    return null;
  }

  return (
    <Nav as="nav" aria-label="Search Breadcrumbs" data-guid="SearchBreadcrumbs">
      <Ol>
        {breadcrumbs.map(({ label, url }) => (
          <Breadcrumb key={url} as="li">
            {/* url here is absolute */}
            <NextLink href={url} prefetch={false} passHref legacyBehavior>
              <a className="inline font-semibold text-link hover:underline">
                {label}
              </a>
            </NextLink>
            <IconChevronRight
              size="small"
              style={{
                margin: spacingInlineNarrow,
                display: 'inline-block',
                verticalAlign: 'text-bottom',
              }}
              color={colors.link.DEFAULT}
            />
          </Breadcrumb>
        ))}
        <BreadcrumbLocation as="li">{location}</BreadcrumbLocation>
      </Ol>
    </Nav>
  );
};

export default SearchBreadcrumbs;
